export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';
export const STATE_INIT = 'STATE_INIT';
export const SEARCH_PARAM = 'SEARCH_PARAM';
export const PAGING_INFO = 'PAGING_INFO';
export const DETAIL_FORM = 'DETAIL_FORM';
export const POPUP_INIT = 'POPUP_INIT';
export const POPUP_SEARCH_PARAMS = 'POPUP_SEARCH_PARAMS';
export const FIND_POPUP_INIT = 'FIND_POPUP_INIT';
export const FIND_POPUP_SEARCH_PARAMS = 'FIND_POPUP_SEARCH_PARAMS';
export const FIND_POPUP_PAGING_INFO = 'FIND_POPUP_PAGING_INFO';

export default {
	STATE_INIT,
	DEFAULT_ASSIGN,
	SEARCH_PARAM,
	PAGING_INFO,
	DETAIL_FORM,
	POPUP_INIT,
	POPUP_SEARCH_PARAMS,
	FIND_POPUP_PAGING_INFO,
	FIND_POPUP_SEARCH_PARAMS,
	FIND_POPUP_INIT
};
